module.exports = __webpack_public_path__ + "img/Morocco.b349ea53.png";